export default "<button #button mat-mini-fab class=\"mat-elevation-z0\" color=\"\"></button>\n"